import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultiUserShareAccessComponent } from './multi-user-share-access.component';
import { MultiUserSelectionListModule } from './multi-user-selection-list/multi-user-selection-list.module';
import { MultiUserAccessTimeModule } from './multi-user-access-time/multi-user-access-time.module';
import { MultiUserTypeModule } from './multi-user-type/multi-user-type.module';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@NgModule({
  declarations: [MultiUserShareAccessComponent],
  imports: [
    CommonModule,
    MultiUserSelectionListModule,
    MultiUserAccessTimeModule,
    MultiUserTypeModule,
    TranslateModule
  ],
  exports: [MultiUserShareAccessComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],

})
export class MultiUserShareAccessModule {}
